/**
 * Weicht die Jira-Site des Tokens von der Umgebung ab, in der dieses CRM
 * läuft (`configuredHost`, der Host aus `JIRA_BASE_URL` — s. API
 * `instance.service.ts`)? Die Customer View folgt dem OAuth-Token des Leads,
 * nicht `JIRA_BASE_URL` — der Lead wählt die Site beim Zustimmen bei
 * Atlassian.
 *
 * Der riskante Fall ist eine Umgebung, deren konfigurierte Site nicht der des
 * Tokens entspricht — typischerweise Staging mit einem Prod-Token: Der Lead
 * arbeitet dann aus dem Cockpit heraus in **echten** Kundentickets. Das ist
 * gewollt (Staging ohne Sandbox-Daten prüfen), darf aber nicht unbemerkt
 * passieren, deshalb färbt genau diese Abweichung das Badge.
 *
 * `configuredHost === null` heißt „Modul nicht konfiguriert" — dann gibt es
 * keine Umgebung, von der abzuweichen wäre.
 */
export function differsFromEnvironment(site: string, configuredHost: string | null): boolean {
  if (configuredHost === null) return false;
  return site.trim().toLowerCase() !== configuredHost.trim().toLowerCase();
}
